fx.ns("desktop.book.edition", class ComponentFactory {

    create(component, model, svg, manual) 
    {
      let componentClass;
      let componentCommands;
      
      switch(component.component_type)
      {
            case "photo":
            case "image":
                componentClass = shared.stage.components.Photo;
                componentCommands = [];
                componentCommands.push({tag : "zoomout", label : fx.text("Zoom -"), icon : fx.assets.zoomoutBtn, type:"button", event : "onZoomOut"});
                componentCommands.push({tag : "zoomin", label : fx.text("Zoom +"), icon : fx.assets.zoominBtn, type:"button", event : "onZoomIn"});
                componentCommands.push({});
                componentCommands.push({tag : "rotate", label : fx.text("Rotation"), icon : fx.assets.rotateBtn, type:"button", event:"onApplyRotate"});
                componentCommands.push({});

                if (!model.creation.is3d)
                {
                  componentCommands.push({tag : "border", label : fx.text("Bord"), icon : fx.assets.borderPhotoBtn, type:desktop.common.toolbar.ToolBarBorderSelector, event : "onBorder" });

                  if (!model.creation.useMedias)
                    componentCommands.push({tag : "masks", label : fx.text("Forme"), icon : fx.assets.masksBtn, type:"scroller", items : model.visibleMasks , event : "onSetMask", field : "photomask" });
                }

                if (!model.creation.useMedias)
                    componentCommands.push({tag : "effects", label : fx.text("Effet"), icon : fx.assets.filterBtn, type:"scroller", items : model.photofilters.filters, event : "onSetEffect", field : "effectName"});

                componentCommands.push({tag : "magiceraser", label : fx.text("Gommer"), icon : fx.assets.eraseIcon, type:"button", event : "onMagicEraser"});
                componentCommands.push({tag : "brightness", label : fx.text("Réglages"), icon : fx.assets.lightBtn, event : "onSetBrightness", type:"brightness"});
                componentCommands.push({});
                componentCommands.push({tag : "senddown", label : fx.text("Descendre"), icon : fx.assets.sendDown, type:"button", event:"onSendDown"});
                componentCommands.push({tag : "sendup", label : fx.text("Remonter"), icon : fx.assets.sendUp, type:"button", event : "onSendUp"});
                componentCommands.push({tag : "remove", label : fx.text("Supprimer"), icon : fx.assets.removeIcon, type:"button", event:"onDelete"});
                                    		
              break;

            case "background":
                componentClass = shared.stage.components.Background;
                componentCommands = [];
              break;

            case "shape":
                componentClass = shared.stage.components.Shape;
                componentCommands = [];   
                componentCommands.push({tag : "border", label : fx.text("Bord"), icon : fx.assets.borderStickerBtn, type:desktop.common.toolbar.ToolBarBorderSelector, event : "onBorder" });
                componentCommands.push({tag : "color", label : fx.text("Couleur"), icon : fx.assets.paletteIcon, type:"colorpicker", field:"backgroundColor", event:"onColor", opacity : true});
                //componentCommands.push({tag : "inverth", label : "Inverser H", icon : fx.assets.mirrorIconH, type:"button", event : "onMirrorH"});
                //componentCommands.push({tag : "invertv", label : "Inverser V", icon : fx.assets.mirrorIconV, type:"button", event : "onMirrorV"});
                componentCommands.push({});
                componentCommands.push({tag : "senddown", label : fx.text("Descendre"), icon : fx.assets.sendDown, type:"button", event:"onSendDown"});
                componentCommands.push({tag : "sendup", label : fx.text("Remonter"), icon : fx.assets.sendUp, type:"button", event : "onSendUp"});
                componentCommands.push({tag : "remove", label : fx.text("Supprimer"), icon : fx.assets.removeIcon, type:"button", event:"onDelete"} );                    
              break;

            case "sticker":
                componentClass = shared.stage.components.Sticker;
                componentCommands = [];
                componentCommands.push({tag : "inverth", label : fx.text("Inverser"), icon : fx.assets.mirrorIconH, type:"button", event : "onMirrorH"});
              //componentCommands.push({tag : "invertv", label : "Inverser V", icon : fx.assets.mirrorIconV, type:"button", event : "onMirrorV"});
                componentCommands.push({});
                componentCommands.push({tag : "senddown", label : fx.text("Descendre"), icon : fx.assets.sendDown, type:"button", event:"onSendDown"});
                componentCommands.push({tag : "sendup", label : fx.text("Remonter"), icon : fx.assets.sendUp, type:"button", event : "onSendUp"});
                componentCommands.push({tag : "remove", label : fx.text("Supprimer"), icon : fx.assets.removeIcon, type:"button", event:"onDelete"});
              break;

            case "text":
                componentClass = shared.stage.components.Text;
                componentCommands = [];
                componentCommands.push({tag : "fontsizeinout", type:"fontsize-button",  class:"narrow", event : "onFontSizeInOut"});
                componentCommands.push({type: "text", field : "fontSizeLabel"});
                componentCommands.push({tag : "fontfamily", type:"font-select", field : "fontFamily", event : "onFontFamily", items : model.fonts });

                if (!model.creation.is3d)
                {
                    if (!model.creation.useMedias)
                    {
                        componentCommands.push({tag : "fontbold", label : fx.text("Gras"), icon : fx.assets.boldBtn, type:"state-button", field : "fontBold", event:"onFontBold", enabledField : "boldEnabled"});
                        componentCommands.push({tag : "fontitalic", label : fx.text("Italic"), icon : fx.assets.italicBtn, type:"state-button", field : "fontItalic", event:"onFontItalic", enabledField : "italicEnabled"});
                    }
                }

                componentCommands.push({});
                componentCommands.push({tag : "textcolor", label : fx.text("Couleur"), icon : fx.assets.textColorBtn, type:"colorpicker", field:"textColor", event:"onTextColor"});

                if (!model.creation.is3d)
                {
                    if (!model.creation.useMedias)
                    {
                        componentCommands.push({tag : "backgroundcolor", label : fx.text("Fond"), icon : fx.assets.textBgColorBtn, type:"colorpicker", field:"backgroundColor", event:"onBackgroundColor", opacity : true});
                        componentCommands.push({tag : "border", label : fx.text("Bord"), icon : fx.assets.borderTextBtn, type:desktop.common.toolbar.ToolBarBorderSelector, event : "onBorder" });
                    }
                }

                componentCommands.push({});
                componentCommands.push({ type:"unique-state-buttons", 
                                        buttons : [  
                                                        {tag : "alignleft", label : fx.text("Gauche"), icon : fx.assets.alignLeftBtn, field:"alignLeft", event:"onSetAlignLeft" },
                                                        {tag : "aligncenter", label : fx.text("Centre"), icon : fx.assets.alignCenterBtn, field:"alignCenter", event:"onSetAlignCenter" },
                                                        {tag : "alignright", label : fx.text("Droite"), icon : fx.assets.alignRightBtn, field:"alignRight", event:"onSetAlignRight" }
                                                    ]
                                        });
                componentCommands.push({});
                componentCommands.push({tag : "senddown", label : fx.text("Descendre"), icon : fx.assets.sendDown, type:"button", event:"onSendDown"});
                componentCommands.push({tag : "sendup", label : fx.text("Remonter"), icon : fx.assets.sendUp, type:"button", event : "onSendUp"});
                componentCommands.push({tag : "remove", label : fx.text("Supprimer"), icon : fx.assets.removeIcon, type:"button", event:"onDelete"});

              break;
              case "pagination":
                var fonts = new fx.ModelArray();
                fonts = model.fonts.getPaginationFonts();
                componentClass = shared.stage.components.Pagination;
                componentCommands = [];
                componentCommands.push({tag : "fontsizeinout", type:"fontsize-button",  class:"narrow", event : "onFontSizeInOut"});
                componentCommands.push({type: "text", field : "fontSizeLabel"});
                componentCommands.push({tag : "fontfamily", type:"font-select", field : "fontFamily", event : "onFontFamily", items : fonts });
                componentCommands.push({});
                componentCommands.push({tag : "textcolor", label : fx.text("Couleur"), icon : fx.assets.textColorBtn, type:"colorpicker", field:"textColor", event:"onTextColor"});

                if (!model.creation.is3d)
                {
                  componentCommands.push({tag : "backgroundcolor", label : fx.text("Fond"), icon : fx.assets.textBgColorBtn, type:"colorpicker", field:"backgroundColor", event:"onBackgroundColor", opacity : true});
                }
              break;
          }
                
      return componentClass ? new componentClass( component, model, svg, manual, componentCommands ) : null;
    }
  });